export default "__VITE_ASSET__DCGRzxjh__"